<template>
  <div>
    <header-top-dashboard
      primary
      :custom-right-content="true"
      :show-back-button="true"
    >
    </header-top-dashboard>
    <v-container fluid class="pt-0 px-6 mt-n16">
      <v-row>
        <v-col class="mt-n3">
          <v-card class="card-shadow mb-6">
            <v-card-text class="card-padding">
              <v-form>
                <v-row>
                  <v-col cols="12" md="12" class="py-0">
                    <h3>Shop Details</h3>
                    <v-divider style="margin-bottom: 15px"></v-divider>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6" class="py-0">
                    <label
                      for=""
                      class="label-color font-weight-600 mb-2 d-block"
                      >Shop Name</label
                    >
                    <v-text-field
                      outlined
                      class="input-style font-size-input text-light-input placeholder-light"
                      placeholder="Shop Name"
                      v-model="shopDetails.name"
                      required
                      :error-messages="
                        getFieldValidationErrors(v$.shopDetails.name.$errors)
                      "
                      @blur="v$.shopDetails.name.$touch"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="py-0">
                    <label
                      for=""
                      class="label-color font-weight-600 mb-2 d-block"
                      >Link Owner</label
                    >

                    <v-select
                      outlined
                      class="input-style font-size-input text-light-input placeholder-light"
                      placeholder="Shop Owner"
                      :items="shopOwners"
                      :item-text="
                        (row) => {
                          return `${row.firstname} ${row.lastname}`;
                        }
                      "
                      item-value="id"
                      v-model="shopDetails.ownerId"
                      required
                      :error-messages="
                        getFieldValidationErrors(v$.shopDetails.ownerId.$errors)
                      "
                      @blur="v$.shopDetails.ownerId.$touch"
                    >
                    </v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="12" class="py-0">
                    <h3>Address Details</h3>
                    <v-divider style="margin-bottom: 15px"></v-divider>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    class="py-0"
                  >
                    <vuetify-google-autocomplete
                      outlined
                      class="input-style font-size-input text-light-input placeholder-light"
                      placeholder="Start typing to search the shop address..."
                      v-model="shopDetails.addressAutocompleteModel"
                      id="createShopAddress"
                      v-on:placechanged="getAddressData"
                      country="za"
                    >
                    </vuetify-google-autocomplete>
                  </v-col>

                  <v-col
                    cols="12"
                    md="4"
                    class="py-0"
                  >
                    <label
                      for=""
                      class="label-color font-weight-600 mb-2 d-block"
                      >Address Line 1</label
                    >
                    <v-text-field
                      outlined
                      class="input-style font-size-input text-light-input placeholder-light"
                      placeholder="Address line 1"
                      v-model="shopDetails.address.addressLine1"
                      :error-messages="
                        getFieldValidationErrors(
                          v$.shopDetails.address.addressLine1.$errors
                        )
                      "
                      @blur="v$.shopDetails.address.addressLine1.$touch"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    md="4"
                    class="py-0"
                  >
                    <label
                      for=""
                      class="label-color font-weight-600 mb-2 d-block"
                      >Address Line 2</label
                    >
                    <v-text-field
                      outlined
                      class="input-style font-size-input text-light-input placeholder-light"
                      placeholder="Address line 2"
                      v-model="shopDetails.address.addressLine2"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    md="4"
                    class="py-0"
                  >
                    <label
                      for=""
                      class="label-color font-weight-600 mb-2 d-block"
                      >Address Line 3</label
                    >
                    <v-text-field
                      outlined
                      class="input-style font-size-input text-light-input placeholder-light"
                      placeholder="Address line 3"
                      v-model="shopDetails.address.addressLine3"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    md="4"
                    class="py-0"
                  >
                    <label
                      for=""
                      class="label-color font-weight-600 mb-2 d-block"
                      >Surburb</label
                    >
                    <v-text-field
                      outlined
                      class="input-style font-size-input text-light-input placeholder-light"
                      placeholder="Surburb"
                      v-model="shopDetails.address.surburb"
                      :error-messages="
                        getFieldValidationErrors(
                          v$.shopDetails.address.surburb.$errors
                        )
                      "
                      @blur="v$.shopDetails.address.surburb.$touch"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    md="4"
                    class="py-0"
                  >
                    <label
                      for=""
                      class="label-color font-weight-600 mb-2 d-block"
                      >City</label
                    >
                    <v-text-field
                      outlined
                      class="input-style font-size-input text-light-input placeholder-light"
                      placeholder="City"
                      v-model="shopDetails.address.city"
                      :error-messages="
                        getFieldValidationErrors(
                          v$.shopDetails.address.city.$errors
                        )
                      "
                      @blur="v$.shopDetails.address.city.$touch"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    md="4"
                    class="py-0"
                  >
                    <label
                      for=""
                      class="label-color font-weight-600 mb-2 d-block"
                      >Province</label
                    >
                    <v-text-field
                      outlined
                      class="input-style font-size-input text-light-input placeholder-light"
                      placeholder="Province"
                      v-model="shopDetails.address.province"
                      :error-messages="
                        getFieldValidationErrors(
                          v$.shopDetails.address.province.$errors
                        )
                      "
                      @blur="v$.shopDetails.address.province.$touch"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    md="4"
                    class="py-0"
                  >
                    <label
                      for=""
                      class="label-color font-weight-600 mb-2 d-block"
                      >Latitude</label
                    >
                    <v-text-field
                      outlined
                      class="input-style font-size-input text-light-input placeholder-light"
                      placeholder="Latitude"
                      v-model="shopDetails.address.latitude"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    md="4"
                    class="py-0"
                  >
                    <label
                      for=""
                      class="label-color font-weight-600 mb-2 d-block"
                      >Longitude</label
                    >
                    <v-text-field
                      outlined
                      class="input-style font-size-input text-light-input placeholder-light"
                      placeholder="Longitude"
                      v-model="shopDetails.address.longitude"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    md="4"
                    class="py-0"
                  >
                    <label
                      for=""
                      class="label-color font-weight-600 mb-2 d-block"
                      >Address Type</label
                    >
                    <v-select
                      outlined
                      class="input-style font-size-input text-light-input placeholder-light"
                      placeholder="Address Type"
                      :items="addressTypes"
                      item-text="value"
                      item-value="key"
                      v-model="shopDetails.address.type"
                      :error-messages="
                        getFieldValidationErrors(
                          v$.shopDetails.address.type.$errors
                        )
                      "
                      @input="v$.shopDetails.address.type.$touch"
                    >
                    </v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="12" class="py-0">
                    <h3>Contact Details</h3>
                    <v-divider style="margin-bottom: 15px"></v-divider>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="2" class="py-0">
                    <label
                      for=""
                      class="label-color font-weight-600 mb-2 d-block"
                      >Country Code</label
                    >
                    <v-text-field
                      outlined
                      class="input-style font-size-input text-light-input placeholder-light"
                      placeholder="Country code"
                      v-model="shopDetails.contact.countryCode"
                      :error-messages="
                        getFieldValidationErrors(
                          v$.shopDetails.contact.countryCode.$errors
                        )
                      "
                      @blur="v$.shopDetails.contact.countryCode.$touch"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" md="6" class="py-0">
                    <label
                      for=""
                      class="label-color font-weight-600 mb-2 d-block"
                      >Contact Number</label
                    >
                    <v-text-field
                      outlined
                      class="input-style font-size-input text-light-input placeholder-light"
                      placeholder="Contact Number"
                      v-model="shopDetails.contact.number"
                      :error-messages="
                        getFieldValidationErrors(
                          v$.shopDetails.contact.number.$errors
                        )
                      "
                      @blur="v$.shopDetails.contact.number.$touch"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" class="py-0">
                    <label
                      for=""
                      class="label-color font-weight-600 mb-2 d-block"
                      >Contact Number Type</label
                    >
                    <v-select
                      outlined
                      class="input-style font-size-input text-light-input placeholder-light"
                      placeholder="Contact Number Type"
                      :items="contactTypes"
                      item-text="value"
                      item-value="key"
                      v-model="shopDetails.contact.type"
                      :error-messages="
                        getFieldValidationErrors(
                          v$.shopDetails.contact.type.$errors
                        )
                      "
                      @blur="v$.shopDetails.contact.type.$touch"
                    >
                    </v-select>
                  </v-col>
                </v-row>

                <v-btn
                  @click="submit"
                  elevation="0"
                  :ripple="false"
                  height="43"
                  :loading="submitButton.isLoading"
                  class="font-weight-600 text-capitalize btn-primary py-3 px-6 rounded-sm me-2"
                  color="#5e72e4"
                  >Update</v-btn
                >
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapStores } from "pinia";
import { useSessionStore } from "@/store/session";
import useVuelidate from "@vuelidate/core";
import { required, requiredIf } from "@vuelidate/validators";
import HeaderTopDashboard from "@/components/HeaderTopDashboard.vue";

export default {
  name: "shops-edit",
  setup() {
    return { v$: useVuelidate() };
  },
  components: {
    HeaderTopDashboard,
  },
  validations() {
    return {
      shopDetails: {
        name: { required, $autoDirty: true },
        ownerId: { required },
        address: {
          type: { required },
          addressLine1: { required },
          surburb: { required },
          city: { required },
          province: { required },
        },
        contact: {
          type: { required },
          countryCode: { required },
          number: { required },
        },
      },
    };
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      addressAutocomplete: true,
      addressTypes: [],
      contactTypes: [],
      shopDetails: {
        name: "",
        ownerId: null,
        addressAutocompleteModel: null,
        address: {
          type: "",
          longitude: "",
          latitude: "",
          addressLine1: "",
          addressLine2: "",
          addressLine3: "",
          surburb: "",
          city: "",
          province: "",
          code: "",
        },
        contact: {
          type: "",
          countryCode: "+27",
          number: "",
        },
      },
      shopOwners: [],
      submitButton: {
        isLoading: false,
      },
    };
  },
  computed: {
    ...mapStores(useSessionStore),
  },
  methods: {
    getFieldValidationErrors(errors) {
      const messages = [];

      for (let i = 0; i < errors.length; i++) {
        messages.push(`${errors[i].$message}`);
      }

      return messages;
    },

    getAddressData(addressData, placeResultData) {
      this.setAddressDetailsFromGooglePlacesApi(
        this.shopDetails.address,
        addressData,
        placeResultData
      );
    },

    async submit() {
      const isFormCorrect = await this.v$.$validate();

      if (!isFormCorrect) {
        this.$notify.warning(
          "Please resolve the validation errors before proceeding!"
        );
        return;
      }

      this.submitButton.isLoading = true;

      const shopObject = {
        name: this.shopDetails.name,
        image_uri: "this.shopDetails.imageUri",
        users: [],
      };

      if (this.shopDetails.ownerId) {
        shopObject.users.push({
          id: this.shopDetails.ownerId,
          role: "shop_owner",
        });
      }

      const addressObject = {
        type: this.shopDetails.address.type,
        address_line_1: this.shopDetails.address.addressLine1,
        address_line_2: this.shopDetails.address.addressLine2,
        address_line_3: this.shopDetails.address.addressLine3,
        surburb: this.shopDetails.address.surburb,
        city: this.shopDetails.address.city,
        province: this.shopDetails.address.province,
        latitude: this.shopDetails.address.latitude.toString(),
        longitude: this.shopDetails.address.longitude.toString(),
      };

      const contactObject = {
        country_code: this.shopDetails.contact.countryCode,
        number: this.shopDetails.contact.number,
        type: this.shopDetails.contact.type,
      };

      const baseUri = `/shops/${this.id}`;
      this.$http
        .patch(baseUri, shopObject, this.sessionStore.getHttpConfig)
        .then(async () => {
          const promises = [];

          if (addressObject.id != null) {
            promises.push(
              this.$http.patch(
                `${baseUri}/address-details/${this.manufacturerDetails.address.id}`,
                addressObject,
                this.sessionStore.getHttpConfig
              )
            );
          } else {
            promises.push(
              this.$http.post(
                `${baseUri}/address-details`,
                addressObject,
                this.sessionStore.getHttpConfig
              )
            );
          }

          if (addressObject.id != null) {
            promises.push(
              this.$http.patch(
                `${baseUri}/contact-details/${this.manufacturerDetails.contact.id}`,
                contactObject,
                this.sessionStore.getHttpConfig
              )
            );
          } else {
            promises.push(
              this.$http.post(
                `${baseUri}/contact-details`,
                contactObject,
                this.sessionStore.getHttpConfig
              )
            );
          }

          return Promise.all(promises).then(() => {
            this.$notify.success("Shop updated successfully!");
          });
        })
        .catch((error) => {
          this.handleHttpError(
            error,
            "An error occurred while saving the shop. Please try again later or contact support."
          );
        })
        .finally(() => {
          this.addressAutocomplete = true;
          this.shopOwners.splice(0);
          this.submitButton.isLoading = false;
        });
    },
  },
  mounted() {
    this.$http
      .get(`/shops/${this.id}`, this.sessionStore.getHttpConfig)
      .then((result) => {
        const shop = result.data.data[0];

        let shopOwnerId = 0;
        if (shop.owners.length > 0) {
          shopOwnerId = shop.owners[0].id;
        }

        let addressDetails = {};
        if (shop.address_details.length > 0) {
          addressDetails = shop.address_details[0];
        }

        let contactDetails = {};
        if (shop.contact_details.length > 0) {
          contactDetails = shop.contact_details[0];
        }

        this.shopDetails.name = shop.name;
        this.shopDetails.ownerId = shopOwnerId;

        this.shopDetails.addressAutocompleteModel =
          addressDetails.address_line_1;
        this.shopDetails.address.type = addressDetails.type;
        this.shopDetails.address.longitude = addressDetails.longitude;
        this.shopDetails.address.latitude = addressDetails.latitude;
        this.shopDetails.address.addressLine1 = addressDetails.address_line_1;
        this.shopDetails.address.addressLine2 = addressDetails.address_line_2;
        this.shopDetails.address.addressLine3 = addressDetails.address_line_3;
        this.shopDetails.address.surburb = addressDetails.surburb;
        this.shopDetails.address.city = addressDetails.city;
        this.shopDetails.address.province = addressDetails.province;
        this.shopDetails.contact.type = contactDetails.type;
        this.shopDetails.contact.countryCode = contactDetails.country_code;
        this.shopDetails.contact.number = contactDetails.number;
      })
      .catch((error) => {
        this.handleHttpError(
          error,
          "An error occurred while loading the shop details. Please try again later or contact support."
        );
      });

    this.fetchUsersByRole("shop_owner")
      .then((result) => {
        this.shopOwners.splice(0);

        for (let i = 0; i < result.data.data.length; i += 1) {
          this.shopOwners.push(result.data.data[i]);
        }
      })
      .catch((error) => {
        this.handleHttpError(
          error,
          "An error occurred while loading shop owners. Please try again later or contact support."
        );
      });

    this.fetchStaticDataByGrouping("addressTypes")
      .then((result) => {
        this.addressTypes.splice(0);

        for (let i = 0; i < result.data.data.length; i += 1) {
          this.addressTypes.push(result.data.data[i]);
        }
      })
      .catch((error) => {
        this.handleHttpError(
          error,
          "An error occurred while loading address types. Please try again later or contact support."
        );
      });

    this.fetchStaticDataByGrouping("contactTypes")
      .then((result) => {
        this.contactTypes.splice(0);

        for (let i = 0; i < result.data.data.length; i += 1) {
          this.contactTypes.push(result.data.data[i]);
        }
      })
      .catch((error) => {
        this.handleHttpError(
          error,
          "An error occurred while loading contact types. Please try again later or contact support."
        );
      });
  },
};
</script>
